// ============================================
// FAL SUTRA — CENTRAL CONFIGURATION FILE
// All business logic, prices, pincodes, etc.
// Edit ONLY this file to change site behavior
// ============================================

const config = {
  // Brand
  brand: {
    name: "FAL SUTRA",
    tagline: "Sehat Ka Asli Raja",
    description: "Premium Fresh Fruit Cups | Delivered at Your Doorstep | No Sugar, No Preservatives.",
    fssaiLicense: "20726038000963",
  },

  // Top Bar / Announcement
  topBar: {
    enabled: true,
    message: "🍎 Free Delivery above ₹299! | 📞 +91 8279238165",
  },

  // Contact
  contact: {
    whatsapp: "918279238165",
    phone: "+91 8279238165",
    phoneRaw: "8279238165",
    email: "falsutra.official@gmail.com",
    address: "Behind Palladium Mall, Opp. Eklavya Sports Academy, Thaltej, Ahmedabad",
    instagram: "falsutra_official",
    instagramUrl: "https://instagram.com/falsutra_official",
    upiId: "iamkrn88@okhdfcbank",
  },

  // Owner Section Images (add more paths here to show in carousel)
  // Recommended Image Size: 1000 x 1200 px (aspect ratio 5:6, portrait) | Format: JPG/WebP
  ownerImages: [
    "/images/owner-cups.jpg",
    "/images/owner-prep.jpg",
    "/images/smit-crafted-with-passion.jpeg",
  ],

  // Colors (Extracted from Logo)
  colors: {
    primary: "#E63946",       // Vibrant Red (strawberry)
    primaryDark: "#C1121F",
    secondary: "#F7A928",     // Warm Orange/Yellow (banana/mango)
    secondaryDark: "#E08D1A",
    accent: "#2D6A4F",        // Fresh Green (leaves)
    accentLight: "#52B788",
    dark: "#1B1B2F",
    light: "#FFF8F0",
    white: "#FFFFFF",
    cream: "#FFF5E8",
    text: "#2B2B2B",
    textLight: "#6B7280",
    gradient: "linear-gradient(135deg, #E63946 0%, #F7A928 100%)",
    gradientDark: "linear-gradient(135deg, #1B1B2F 0%, #2D3561 100%)",
  },

  // Products (Monthly Subscription Plans)
  // ---------------------------------------------------------------
  // IMAGE DIMENSIONS GUIDE:
  // Product Card (Home/Menu):     700 x 560 px  (5:4 landscape)
  // Product Detail Page:         1100 x 1000 px (11:10 near-square)
  // Format: JPG or WebP | Keep file size under 300KB for fast load
  // ---------------------------------------------------------------
  products: [
    {
      id: "the-lite-plan",
      name: "The Lite Plan",
      shortName: "The Green Machine",
      type: "Signature",
      tagline: "Nature's Ultimate Detox & Energy Boost",
      description: "Start your health journey with our Lite Plan — a perfect blend of seasonal fruits designed to detox, hydrate, and energize your body every single day. Ideal for beginners and health-conscious individuals who want a daily dose of freshness without breaking the bank.",
      ingredients: ["Water Melon", "Muskmelon", "Papaya", "Banana"],
      toppings: "Topped with Pomegranate",
      bestFor: "Best for Quick Energy, Detox, daily wellness",
      monthlyPrice: 1699,
      sellingPricePerCup: 70,
      planDurationDays: 24,
      image: "/images/the-lite-plan.jpeg", // 700x560px (5:4 landscape) recommended
      badge: "🌿 New Launch",
      color: "#2D6A4F",
    },
    {
      id: "classic-the-desk-detox",
      name: "Classic (The Desk Detox)",
      shortName: "The Daily Fit",
      type: "Standard",
      tagline: "Your Daily Dose of Hydration & Fiber",
      description: "Our best-selling Classic plan is designed for the modern professional. Packed with fibre-rich fruits and superfoods, this plan keeps you energized, focused, and healthy throughout your workday. The perfect desk companion for those who refuse to compromise on health.",
      ingredients: ["Water Melon", "Muskmelon", "Papaya", "Apple"],
      toppings: "Topped with Pomegranate, strawberries & pumpkin seeds",
      bestFor: "Morning breakfast, digestion, quick energy",
      monthlyPrice: 1899,
      sellingPricePerCup: 79,
      planDurationDays: 24,
      image: "/images/standard-cup.jpeg", // 700x560px (5:4 landscape) recommended
      badge: "🍎 Best Seller",
      color: "#E63946",
    },
    {
      id: "vip-the-ceos-exotic-bowl",
      name: "VIP (The CEO's Exotic Bowl)",
      shortName: "The Executive Recovery",
      type: "Premium",
      tagline: "The Immunity Booster",
      description: "The ultimate premium experience — handpicked exotic fruits, loaded with superfoods and imported ingredients. Designed for executives, fitness enthusiasts, and anyone who demands the absolute best. This is not just a fruit bowl — it's a lifestyle statement.",
      ingredients: ["Pineapple", "Kiwi", "Dragon Fruit", "Imported Pears"],
      toppings: "Loaded with Blueberries, pomegranates, pumpkin seeds & sunflower seeds",
      bestFor: "Post-workout recovery, skin glow, executive wellness",
      monthlyPrice: 3299,
      sellingPricePerCup: 137,
      planDurationDays: 24,
      image: "/images/premiume-mix-cup.jpeg", // 700x560px (5:4 landscape) recommended
      badge: "👑 VIP Choice",
      color: "#F7A928",
    },
  ],

  // Subscription Plans
  subscriptions: {
    monthlyNote: "24 Days (Mon to Sat)",
  },

  // Bulk Orders
  bulkOrders: [
    { range: "10–25 Cups", discount: "Flat 10% OFF" },
    { range: "", price: "25+ Cups" },
    // { range: "25+ Cups", price: "Starts @ ₹39/cup only!" },
    { range: "50+ Cups", price: "Custom Pricing (Call Us)" },
  ],

  // Serviceable Pincodes (Thaltej area, Ahmedabad)
  serviceablePincodes: [
    "380059",
    "380054",
    "380052",
    "380015",
    "380060",
    "380061",
  ],

  // Delivery
  delivery: {
    radiusKm: 5,
    baseArea: "Thaltej, Ahmedabad",
    freeDeliveryAbove: 299,
    freeDeliveryMinBowls: 3,
    deliveryCharge: 299,
    estimatedTime: "30–45 minutes",
  },

  // Discount Rules
  discounts: {
    bulkTenPercent: 10,
    bulkMinCups: 10,
    subscriptionSavings: "Save up to 20%",
  },

  // Testimonials
  testimonials: [
    {
      name: "Sandy",
      role: "Gym Trainer",
      review: "Best post-workout meal in Thaltej! Fresh, tasty, and packed with energy.",
      image: "/images/gym-client1.jpg",
      rating: 5,
    },
    {
      name: "Rahul",
      role: "Fitness Enthusiast",
      review: "I replaced my evening snacks with FAL SUTRA cups. Feeling fitter than ever!",
      image: "/images/gym-client2.jpg",
      rating: 5,
    },
    {
      name: "Amit",
      role: "Corporate Professional",
      review: "The subscription plan is a game-changer. Fresh fruits at my desk every morning!",
      image: "/images/gym-client3.jpg",
      rating: 5,
    },
  ],

  // Services
  services: [
    {
      id: "corporate",
      icon: "🏢",
      title: "Corporate Wellness (B2B)",
      description: "Replace unhealthy office snacks with FAL SUTRA fruit cups. Daily/weekly bulk delivery for your team.",
      benefits: ["Productivity boost", "Fewer sick days", "Flat discount on 20+ cups"],
    },
    {
      id: "gym",
      icon: "🏋️",
      title: "Gym & Academy Fuel",
      description: "Pre & post-workout nutrition delivered at gym gate. Zero operational effort for gym owners.",
      benefits: ["Delivered at gym gate", "Pre & post-workout", "Zero effort for owners"],
    },
    {
      id: "societies",
      icon: "🏢",
      title: "Societies & Residential Complexes",
      description: "Social wellness for your community. Bulk delivery with flexible plans for residents. Healthy living made easy.",
      benefits: ["Healthy living", "Community engagement", "Immunity boost for residents"],
    },
    {
      id: "subscription",
      icon: "📅",
      title: "Monthly Subscriptions",
      description: "Daily fresh cup delivery with flexible plans. Never miss your nutrition again.",
      benefits: ["24-Day Monthly Plan", "Best value pricing", "Daily doorstep delivery"],
    },
    {
      id: "hyperlocal",
      icon: "🚀",
      title: "Hyperlocal Quick Commerce",
      description: "Delivery within 5 KM radius of Thaltej. Lightning fast, spill-proof packaging.",
      benefits: ["Within 5 KM radius", "30-45 min delivery", "Spill-proof packaging"],
    },
    // {
    //   id: "Cooming-Soon",
    //   icon: "🚀",
    //   title: "Cooming Soon",
    //   description: "Working on expanding our delivery radius and introducing new services. Stay tuned for updates!",
    //   benefits: ["Within 5 KM radius", "30-45 min delivery", "Spill-proof packaging"],
    // },
  ],

  // Corporate Page Plans
  // Plan Card Image: 860 x 600 px (3:2 landscape) | Format: JPG/WebP
  corporatePlans: [
    {
      id: "corporate-classic",
      header: "Classic (The Desk Detox)",
      description: "Boost your team's productivity with our Classic Corporate plan. A daily dose of fibre-rich fruits, superfoods, and natural energy — delivered fresh to your office every working day. Replace unhealthy office snacks with nature's best fuel.",
      ingredients: ["Water Melon", "Muskmelon", "Papaya", "Apple"],
      toppings: "Topped with Pomegranate, strawberries & pumpkin seeds",
      bestFor: "Office teams, daily desk nutrition, productivity boost",
      monthlyPrice: 1799,
      sellingPricePerCup: 75,
      planDurationDays: 24,
      image: "/images/standard-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#E63946",
      whatsappMessage: "Hi FALSUTRA! 🏢 I want to inquire about the Corporate Wellness Fruit Bowls for my office team. Let's connect!",
    },
    {
      id: "corporate-vip",
      header: "VIP (The CEO's Exotic Bowl)",
      description: "The ultimate premium corporate experience — handpicked exotic fruits loaded with superfoods for your leadership team. Impress clients, fuel executives, and elevate your corporate wellness game to the next level.",
      ingredients: ["Pineapple", "Kiwi", "Dragon Fruit", "Imported Pears"],
      toppings: "Loaded with Blueberries, pomegranates, pumpkin seeds & sunflower seeds",
      bestFor: "Executive wellness, client meetings, leadership teams",
      monthlyPrice: 3199,
      sellingPricePerCup: 133,
      planDurationDays: 24,
      image: "/images/premiume-mix-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#F7A928",
      whatsappMessage: "Hi FALSUTRA! 🏢 I want to inquire about the Corporate Wellness Fruit Bowls for my office team. Let's connect!",
    },
  ],

  // Gym Chains Page Plans
  // Plan Card Image: 860 x 600 px (3:2 landscape) | Format: JPG/WebP
  gymPlans: [
    {
      id: "gym-classic",
      header: "Classic (The Muscle Hydrator)",
      description: "Fuel your workouts with nature's best hydration. Our Classic Gym plan delivers a perfectly balanced mix of hydrating fruits and natural electrolytes — ideal for pre and post-workout recovery. Zero artificial additives, maximum performance.",
      ingredients: ["Water Melon", "Muskmelon", "Papaya", "Apple"],
      toppings: "Topped with Pomegranate, strawberries & pumpkin seeds",
      bestFor: "Pre/post workout, muscle recovery, gym members",
      monthlyPrice: 1699,
      sellingPricePerCup: 71,
      planDurationDays: 24,
      image: "/images/standard-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#E63946",
      whatsappMessage: "Hi FALSUTRA! 💪 I am looking for daily healthy nutrition. I want to subscribe to the CLASSIC Monthly Plan. Please share the payment details! 🍉",
    },
    {
      id: "gym-vip",
      header: "VIP (The Alpha Exotic Flex)",
      description: "For the serious athlete who demands premium nutrition. Exotic fruits packed with antioxidants, natural immunity boosters, and recovery-enhancing superfoods. The ultimate post-workout reward delivered straight to your gym.",
      ingredients: ["Pineapple", "Kiwi", "Dragon Fruit", "Imported Pears"],
      toppings: "Loaded with Blueberries, pomegranates, pumpkin seeds & sunflower seeds",
      bestFor: "Serious athletes, post-workout recovery, skin glow",
      monthlyPrice: 2999,
      sellingPricePerCup: 125,
      planDurationDays: 24,
      image: "/images/premiume-mix-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#F7A928",
      whatsappMessage: "Hi FALSUTRA! 👋 I live in Thaltej (5KM Radius) and I want to start the VIP Premium Monthly Plan. Let's lock my Alpha Bowl! 👑",
    },
  ],

  // Societies Page Plans
  // Plan Card Image: 860 x 600 px (3:2 landscape) | Format: JPG/WebP
  societyPlans: [
    {
      id: "society-classic",
      header: "Classic (The Family Shield)",
      description: "Bring health to your entire family and community. Our Classic Society plan delivers fresh, nutritious fruit bowls daily to your residential society — perfect for families who want natural immunity and daily wellness without any hassle.",
      ingredients: ["Water Melon", "Muskmelon", "Papaya", "Apple"],
      toppings: "Topped with Pomegranate, strawberries & pumpkin seeds",
      bestFor: "Families, daily nutrition, community wellness",
      monthlyPrice: 1899,
      sellingPricePerCup: 80,
      planDurationDays: 24,
      image: "/images/standard-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#E63946",
      whatsappMessage: "Hi FALSUTRA! 👋 I am looking for daily healthy nutrition. I want to subscribe to the CLASSIC Monthly Plan. Please share the payment details! 🍉",
    },
    {
      id: "society-vip",
      header: "VIP (The Royal Breakfast)",
      description: "The premium family wellness experience. Exotic imported fruits, loaded with superfoods and immunity boosters — a royal breakfast delivered to your doorstep every morning. Elevate your family's health with the finest nature has to offer.",
      ingredients: ["Pineapple", "Kiwi", "Dragon Fruit", "Imported Pears"],
      toppings: "Loaded with Blueberries, pomegranates, pumpkin seeds & sunflower seeds",
      bestFor: "Premium families, immunity boost, royal breakfast",
      monthlyPrice: 3299,
      sellingPricePerCup: 138,
      planDurationDays: 24,
      image: "/images/premiume-mix-cup.jpeg", // 860x600px (3:2 landscape) recommended
      color: "#F7A928",
      whatsappMessage: "Hi FALSUTRA! 👋 I live in Thaltej (5KM Radius) and I want to start the VIP Premium Monthly Plan. Let's lock my Alpha Bowl! 👑",
    },
  ],

  // Terms & Conditions
  termsAndConditions: {
    title: "The FALSUTRA Standard & Policies",
    sections: [
      {
        heading: "Uncompromising Quality & Portions",
        content: "Our promise is to deliver the freshest and finest fruits to you. FALSUTRA reserves the right to adapt our menu, portion sizes, and pricing to align with seasonal availability and premium market standards.",
      },
      {
        heading: "The Chiller Box Protocol (Freshness Guaranteed)",
        content: "Your premium bowl stays completely fresh because we store it in an ice-packed 'FALSUTRA Chiller Box' and maintain daily photo-proof of freshness. Please note: To ensure peak nutrition and hygiene, please consume your bowl immediately upon pickup. FALSUTRA is not liable for the quality of the bowl once it leaves our temperature-controlled box.",
      },
      {
        heading: "Safe Drop-off & Pickup",
        content: "Your personalised bowl is placed in the designated box with your name tag. FALSUTRA guarantees safe drop-off, but cannot take responsibility for bowls misplaced by third parties. Please pick up your daily dose of health promptly!",
      },
    ],
    supportEmail: "falsutra.official@gmail.com",
    supportNote: "We value your feedback. For any queries, diet adjustments, or genuine feedback, write directly to the founder's desk.",
  },

  // WhatsApp message template for monthly plan orders
  getWhatsAppPlanOrderUrl: (planName, quantity, monthlyPrice, totalPrice, deliveryCharge, pincode) => {
    const deliveryText = deliveryCharge > 0
      ? `🚚 Delivery Charge: ₹${deliveryCharge}`
      : `🚚 Delivery: FREE`;
    const message = encodeURIComponent(
      `Hello FAL SUTRA 👋\n\nI want to subscribe:\n📋 Plan: ${planName}\n📦 Quantity: ${quantity} subscription(s)\n💰 Plan Price: ₹${monthlyPrice.toLocaleString('en-IN')}/month each\n${deliveryText}\n💵 Total Amount: ₹${totalPrice.toLocaleString('en-IN')}\n📍 Delivery Pincode: ${pincode}\n\nPlease confirm my subscription!`
    );
    return `https://wa.me/918279238165?text=${message}`;
  },

  getWhatsAppUrl: (message) => {
    return `https://wa.me/918279238165?text=${encodeURIComponent(message)}`;
  },

  // Trial drop order
  getWhatsAppTrialUrl: (pincode) => {
    const message = encodeURIComponent(
      `Hello FAL SUTRA 👋\n\nI want to book a 1 Day Paid Trial Drop!\n💰 Price: ₹99\n📍 Delivery Pincode: ${pincode || 'N/A'}\n\nPlease confirm my trial order!`
    );
    return `https://wa.me/918279238165?text=${message}`;
  },

  // Animations toggle
  animations: {
    enabled: true,
    heroFadeIn: true,
    cardHoverLift: true,
    smoothScrollReveal: true,
    buttonRipple: true,
  },
};

export default config;
